/**
 * @name setAcdnToggle.js
 */

class setAcdnToggle {
    constructor() {
        this.flag = document.querySelectorAll(".acdn-toggle");
        if (!this.flag) return;
        this.acdnToggle = this.flag;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.acdnToggle.forEach((el) => el.addEventListener("click", (e) => this.__event(e.currentTarget)));
    }

    /**
     * @name __event 
     */
    __event(e) {
        let btn = e;
        let box = e.parentNode.nextElementSibling;
        let flag = btn.getAttribute("aria-expanded");

        if (flag === "true") {
            btn.setAttribute("aria-expanded", false);
            box.setAttribute("aria-hidden", true);
        } else {
            btn.setAttribute("aria-expanded", true);
            box.setAttribute("aria-hidden", false);
        }
    }
}

export default setAcdnToggle;